export const headerBits = [8,7,6,5,4,3,2,1]
